import React from "react";
import {withRouter} from 'react-router-dom';
import queryString from 'qs'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Icon from "@material-ui/core/Icon/Icon";

import ToolTipIcon from "views/Components/ToolTipIcon"

import { verifyPassword, verifyEmail, verifyLength, setToolTipArray } from "../../../assets/helpers/formHelper";

import axios from "axios";
import { getApiHeaders } from "../../../assets/helpers/apiHelper";
import { getSearchString } from "../../../assets/helpers/urlHelper";
import { API_ROOT } from 'api-config';

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  }
};

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    var isProviderSignup;
    var signupType;
    var emailState = '';
    var password1State = '';
    var password2State = '';
    switch (this.props.location.pathname) {
      case '/signupProvider':
        signupType = 'provider'
        break
      case '/signupEmployer':
        signupType = 'employer'
        break
      default:
        signupType = 'patient'
        break
    }
    if (this.props.location.pathname === '/signupProvider') {
      isProviderSignup = true
    } else {
      isProviderSignup = false
    }
    const userId = sessionStorage.getItem('userId')
    if (userId) {
      //if the userid is already set, there is no need to enter a username or password
      emailState = 'success'
      password1State = 'success';
      password2State = 'success';
      isProviderSignup = true;
      signupType = 'provider'
    }
    this.state = {
      firstname: "",
      firstnameState: "",
      lastname: "",
      lastnameState: "",
      email: "",
      emailState: emailState,
      password1: "",
      password1State: password1State,
      password2: "",
      password2State: password2State,
      usernameErrorMessage: '',
      passwordMatchErrorMessage: '',
      userType: '',
      lastNameFieldLabel: '',
      showFirstNameField: '',
      isProviderSignup: isProviderSignup,
      tooltips: {},
      signupType: signupType,
      userId: userId,
      referralCode: '',
      headerText: "Let's start with the basic information"
    };
  }
  sendState() {
    return this.state;
  }

  change(event, stateName, type, stateNameEqualTo) {

    switch (type) {
      case "email":
        if (verifyEmail(event.target.value)) {
          this.setState({
            [stateName + "State"]: "success",
            usernameErrorMessage: ''
          });
          this.checkUniqueUsername(event.target.value)
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (verifyPassword(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "passwordMatch":
        if (event.target.value && event.target.value === this.state.password1) {
          this.setState({
            [stateName + "State"]: "success",
            passwordMatchErrorMessage: ''
          });
        } else {
          this.setState({
            [stateName + "State"]: "error",
            passwordMatchErrorMessage: "The passwords do not match."
          });
        }
        break;
      default:
        break;
    }

    this.setState({ [stateName]: event.target.value });
  }

  checkUniqueUsername(username) {
      axios.get(`${API_ROOT}/checkUser/?username=` + username, { headers: getApiHeaders() })
        .then(res => this.setUniqueUsername(res.data.message ));
  }

  setUniqueUsername(res) {
    if (res === 'username taken') {
      this.setState({
        emailState: "error",
        usernameErrorMessage: "The username is already taken."
      });
    }
  }

  isValidated() {
    if (
      this.state.firstnameState === "success" &&
      this.state.lastnameState === "success" &&
      this.state.emailState === "success" &&
      this.state.password1State === "success" &&
      this.state.password2State === "success"
    ) {
      return true;
    } else {
      if (this.state.firstnameState !== "success") {
        this.setState({ firstnameState: "error" });
      }
      if (this.state.lastnameState !== "success") {
        this.setState({ lastnameState: "error" });
      }
      if (this.state.emailState !== "success") {
        this.setState({ emailState: "error" });
      }
      if (this.state.password1State !== "success") {
        this.setState({ password1State: "error" });
      }
      if (this.state.password2State !== "success") {
        this.setState({ password2State: "error" });
      }
    }
    return false;
  }

  componentDidMount() {
    if (this.state.signupType === 'provider' || this.state.signupType === 'employer') {
      var userType;
      if (this.state.signupType === 'provider') {
        userType = 'organization'
      } else if (this.state.signupType === 'employer') {
        userType = 'employer'
      }
      this.setState({
        firstnameState: "success",
        userType: userType,
        lastNameFieldLabel: 'Company',
        showFirstNameField: false
      })
    } else {
      this.setState({
        firstnameState: "",
        userType: 'patient',
        lastNameFieldLabel: 'Last Name',
        showFirstNameField: true
      })
    }
    var formType = ''
    switch (this.state.signupType) {
      case "provider":
        formType = 'registrationUserProvider'
        break
      case "employer":
        formType = 'registrationUserEmployer'
        break
      default:
        formType = 'registrationUser'
        break
    }
    axios.get(`${API_ROOT}/toolTip/?formType=` + formType, { headers: getApiHeaders() })
      .then(res => this.setTooltips({ responseMessage: res.data }));
    const searchString = getSearchString(this.props.location.search)
    const paramValues = queryString.parse(searchString)

    if (paramValues.referralCode) {
      this.setState({
        referralCode: paramValues.referralCode
      })
    }

    if (paramValues.provider) {
      this.setState({
        headerText: "Please provide your name, email address and choose an account password."
      })
    }
  }

  setTooltips(tooltipData) {
    this.setState({
      tooltips: setToolTipArray(tooltipData)
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            {this.state.headerText}
          </h4>
        </GridItem>
        <GridItem xs={12} sm={6}>
          <span style={this.state.showFirstNameField ? {} : { display: 'none' }}>
            <CustomInput
              success={this.state.firstnameState === "success"}
              error={this.state.firstnameState === "error"}
              labelText={
                <span>
                  First Name <small>(required)</small>
                </span>
              }
              id="firstname"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.change(event, "firstname", "length", 2),

              }}
            />
          </span>
          <CustomInput
            success={this.state.lastnameState === "success"}
            error={this.state.lastnameState === "error"}
            labelText={
              <span>
                {this.state.lastNameFieldLabel} <small>(required)</small>
              </span>
            }
            id="lastname"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, "lastname", "length", 2),

            }}
          />
          <span style={this.state.userId ? { display: 'none' } : {}}>
            <CustomInput
              success={this.state.emailState === "success"}
              error={this.state.emailState === "error"}
              labelText={
                <span>
                  Email <small>(required)</small>
                </span>
              }
              id="email"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.change(event, "email", "email"),
                endAdornment: (
                  <ToolTipIcon
                    tooltipText={this.state.tooltips['email']}
                  />
                )
              }}
            />
            <p id="usernameErrorMessage">
              {this.state.usernameErrorMessage}
            </p>
              <CustomInput
              success={this.state.password1State === "success"}
              error={this.state.password1State === "error"}
              labelText={
                <span>
                  Password <small>(required)</small>
                </span>
              }
              id="password1"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.change(event, "password1", "password"),
                type: "password",
                endAdornment: (
                  <InputAdornment position="end">
                    <Icon className={classes.inputAdornmentIcon}>
                      lock_outline
                    </Icon>
                  </InputAdornment>
                )
              }}
            />
            <p>
              Your password must be at least 8 characters long, contain a number, an uppercase letter, a lowercase letter and a special character (!#@$%^&*)(+=._-).
            </p>
            <CustomInput
              success={this.state.password2State === "success"}
              error={this.state.password2State === "error"}
              labelText={
                <span>
                  Password, again <small>(required)</small>
                </span>
              }
              id="password2"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.change(event, "password2", "passwordMatch"),
                type: "password",
                endAdornment: (
                  <InputAdornment position="end">
                    <Icon className={classes.inputAdornmentIcon}>
                      lock_outline
                    </Icon>
                  </InputAdornment>
                )
              }}
            />
            <p id="passwordMatchErrorMessage">
              {this.state.passwordMatchErrorMessage}
            </p>
          </span>
        </GridItem>

      </GridContainer>
    );
  }
}

export default withRouter(withStyles(style)(UserInfo));
